// Mock data for Emre Guner Personal Hub

export const heroData = {
  headline: "Emre Guner",
  subheadline: "Ai Content Creator",
  image: "/images/Untitled design (25).png",
  latestVideo: {
    thumbnail: "/images/workshop_whatsapp_thumbnail.png",
    url: "https://youtube.com/@MrGunnerAi"
  }
};

export const trustBadges = [
  { label: "Fortune 500 Advisor", icon: "briefcase" },
  { label: "6,800+ Community", icon: "users" },
  { label: "50+ Automations Shipped", icon: "zap" },
  { label: "Big 4 Alumni", icon: "award" }
];

export const stats = [
  { number: "50+", label: "Automations Delivered" },
  { number: "6,800+", label: "Community Members" },
  { number: "4", label: "Continents Served" }
];

export const partners = [
  { name: "Google" },
  { name: "Microsoft" },
  { name: "n8n" },
  { name: "Make" },
  { name: "HubSpot" },
  { name: "OpenAI" }
];

export const clients = [
  { name: "Big 4 Consulting" },
  { name: "Toshiba" },
  { name: "Fortune 500 Retailer" },
  { name: "Honeywell" }
];

export const linkHubItems = [
  {
    title: "Leda",
    subtitle: "AI Marketing Agency",
    url: "#leda",
    icon: "🏠",
    tag: "Company"
  },
  {
    title: "Community / Courses",
    subtitle: "Join 6,800+ members on Skool",
    url: "#community",
    icon: "🎓",
    tag: "Education"
  },
  {
    title: "Speaking & Seminars",
    subtitle: "Book a keynote or workshop",
    url: "#seminars",
    icon: "🎤",
    tag: "Events"
  },
  {
    title: "Blog",
    subtitle: "AI automation insights & case studies",
    url: "#blog",
    icon: "✍️",
    tag: "Content"
  },
  {
    title: "Experiments",
    subtitle: "Live AI projects & prototypes",
    url: "#experiments",
    icon: "🧪",
    tag: "Labs"
  },
  {
    title: "Contact",
    subtitle: "Let's build something together",
    url: "mailto:emre@emreguner.com",
    icon: "📬",
    tag: "Connect"
  }
];

export const resources = [
  {
    id: "whatsapp-ai-agent",
    title: "WhatsApp AI Sales Agent",
    tag: "Event",
    tags: ["Video", "Event", "Files"],
    status: "live",
    image: "/images/workshop_whatsapp_thumbnail.png",
    description: "AI agent that handles 500+ daily customer inquiries on WhatsApp, processes voice notes, and manages inventory lookups automatically.",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    leadMagnetTitle: "The WhatsApp Automation Blueprint",
    leadMagnetDescription: "Download the complete technical setup guide and n8n workflow templates for building your own AI sales agent.",
    details: "This resource covers the end-to-end architecture of a production-ready WhatsApp AI agent. Learn how to handle media, maintain conversation state, and integrate with real-time inventory systems."
  },
  {
    id: "ai-content-pipeline",
    title: "AI Content Pipeline",
    tag: "Case Study",
    tags: ["Guide", "Files"],
    status: "case-study",
    image: "https://images.unsplash.com/photo-1763718432504-7716caff6e99?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxBSSUyMGRhc2hib2FyZHxlbnwwfHx8fDE3NzExNzQyNzJ8MA&ixlib=rb-4.1.0&q=85",
    description: "End-to-end automation for real estate content — from listing data to published social posts in under 60 seconds.",
    videoUrl: "",
    leadMagnetTitle: "Real Estate AI Stack",
    leadMagnetDescription: "Get the directory of tools and prompts I use to automate 80% of content creation for property listings.",
    details: "Automating content is more than just using GPT. It's about data bridges. This resource shows you how to connect Zillow data to Canva and Instagram via n8n."
  },
  {
    id: "lead-qualification-engine",
    title: "Lead Qualification Engine",
    tag: "Beta",
    tags: ["Demo", "Video"],
    status: "beta",
    image: "https://images.unsplash.com/photo-1761195696590-3490ea770aa1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxhdXRvbWF0aW9uJTIwdGVjaHxlbnwwfHx8fDE3NzExNzQyODV8MA&ixlib=rb-4.1.0&q=85",
    description: "AI-powered lead scoring system that qualifies prospects and routes them to the right sales rep in real-time.",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    leadMagnetTitle: "Qualification Script Library",
    leadMagnetDescription: "The exact system prompts I use to qualify high-ticket B2B leads via AI voice and chat.",
    details: "Reduce response time to zero. This engine qualifies leads 24/7 and only puts the highest intent prospects on your calendar."
  }
];

export const instagramEmbeds = [
  {
    id: 1,
    url: "https://www.instagram.com/reel/DDXkBXNqfaD/",
    caption: "Istanbul AI Workshop & Keynote",
    image: "/images/event-flyer.jpg"
  },
  {
    id: 2,
    url: "https://www.instagram.com/reel/DDIGkKhqwCl/",
    caption: "AI Workshop Demo"
  }
];

export const meetupGroups = [
  {
    name: "Istanbul AI & Agile",
    members: "4,987",
    url: "https://www.meetup.com/istanbul-open-agile-meetup/"
  },
  {
    name: "AI Agent Workshops",
    members: "1,873",
    url: "https://www.meetup.com/tr-TR/tech-workshop/"
  }
];

export const blogPosts = [
  {
    id: 1,
    label: "Case Study",
    title: "How a WhatsApp AI Agent Saved 50+ Hours Per Week",
    excerpt: "A wholesale vendor was drowning in messages. Here's how we built an AI agent that handles orders, checks inventory, and processes sales — all automatically.",
    url: "/blog/whatsapp-ai-agent"
  },
  {
    id: 2,
    label: "Guide",
    title: "The €7K AI Automation Service: A Complete Blueprint",
    excerpt: "Stop selling $200 chatbot wrappers. Learn how to package N8N + WhatsApp automation as a premium service that businesses actually need.",
    url: "/blog/ai-automation-service"
  },
  {
    id: 3,
    label: "Insights",
    title: "Why AI Marketing Will Dominate Real Estate in 2026",
    excerpt: "The agencies that embrace AI-powered content, lead gen, and customer service will capture 80% of the market. Here's the playbook.",
    url: "/blog/ai-marketing-real-estate"
  }
];

export const socialLinks = [
  { name: "LinkedIn", url: "https://www.linkedin.com/in/emregunner/", icon: "Linkedin" },
  { name: "YouTube", url: "https://www.youtube.com/@MrGunnerAi", icon: "Youtube" },
  { name: "Instagram", url: "https://www.instagram.com/mrgunner.ai/", icon: "Instagram" }
];
